var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanProIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500244,
    y: 1.36755,
    width: 55,
    height: 55,
    rx: 3.5,
    fill: "url(#paint0_linear_66_10664)",
    stroke: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_10664",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: 0.867554,
    width: 56,
    height: 56,
    rx: 2,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_10664)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7363 7.99464C68.7254 8.55717 69.5468 9.3731 70.1159 10.3585C70.6849 11.3438 70.9811 12.463 70.974 13.6009V34.5639C70.974 36.8922 69.6991 39.0391 67.6414 40.1701L48.2152 52.459C47.2521 52.9878 46.1712 53.265 45.0725 53.265C43.9738 53.265 42.8928 52.9878 41.9297 52.459L22.5036 40.1701C21.4968 39.6199 20.6563 38.8093 20.07 37.8231C19.4837 36.8369 19.1732 35.7112 19.1709 34.5639V13.598C19.1709 11.2698 20.4458 9.12568 22.5036 7.99464L41.9297 -3.45961C42.9213 -4.00631 44.0351 -4.29303 45.1674 -4.29303C46.2997 -4.29303 47.4136 -4.00631 48.4051 -3.45961L67.8313 7.99464H67.7363Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "color-burn"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1347 18.5829C42.7515 18.9337 43.2638 19.4426 43.6187 20.0571C43.9736 20.6717 44.1583 21.3697 44.1539 22.0793V35.1532C44.1539 36.6052 43.3588 37.9442 42.0754 38.6496L29.96 46.3137C29.3594 46.6435 28.6853 46.8164 28 46.8164C27.3148 46.8164 26.6407 46.6435 26.04 46.3137L13.9247 38.6496C13.2967 38.3064 12.7726 37.8009 12.4069 37.1858C12.0413 36.5707 11.8476 35.8687 11.8462 35.1532V22.0775C11.8462 20.6255 12.6413 19.2883 13.9247 18.5829L26.04 11.4393C26.6584 11.0984 27.3531 10.9196 28.0593 10.9196C28.7654 10.9196 29.4601 11.0984 30.0785 11.4393L42.1939 18.5829H42.1347Z",
    fill: "url(#paint1_linear_66_10664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_10664",
    x1: 28.0002,
    y1: 37.3184,
    x2: 28.0002,
    y2: 56.8676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11766,
    stopColor: "#FFEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995449,
    stopColor: "#F6DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_10664",
    x1: 36.2482,
    y1: 15.2174,
    x2: 28.0001,
    y2: 46.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5041,
    stopColor: "#FF898D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanProIcon);
export default __webpack_public_path__ + "static/media/PlanProIcon.656b0ccec78d62823a2a42fd28a6b493.svg";
export { ForwardRef as ReactComponent };